import { ROUTES_NAMES } from '@/constants';
import { beforeEnterLoginRoute } from './loginNavigationGuards';
import { RouteRecordRaw } from 'vue-router';
import LoginPanel from '@/views/LoginPanel.vue';

const loginRoute: RouteRecordRaw = {
  path: '/login',
  name: ROUTES_NAMES.login,
  component: LoginPanel,
  beforeEnter: beforeEnterLoginRoute
};

export default loginRoute;
